import { cn } from "@/lib/utils";
import Link from "next/link";
import { usePathname } from "next/navigation";
import ColorStyleContext from "@/lib/providers/color-style-privider";
import { useContext } from "react";

type Props = {
    href: string;
    [key: string]: any;
};

export const NavLink = ({ href, ...props }: Props) => {
    const currentPath = usePathname();
    const colorStyle = useContext(ColorStyleContext);

    return (
        <Link
            href={decodeURIComponent(href)}
            style={{ 
                "--dynamic-color": colorStyle?.menuTextNormal ?? "#3d3d3d",
                "--dynamic-hover-color": colorStyle?.menuTextHover ?? "#254b7c",
            } as React.CSSProperties}
            className={cn(
                "font-light text-sm self-center dynamic-color",
                currentPath == href ? "font-bold" : "",
            )}
            {...props}
        />
    );
};
